export interface Lamp {
  key: string;
  png: string;
  labelKey: string;
  onKey: string;
  offKey: string;
  on: boolean;
}

// Same png ↔ indicator pairing as the legacy Alert Detail and Vehicle Detail pages.
const LAMPS: Omit<Lamp, 'on'>[] = [
  { key: 'RedStopLamp', png: 'stop', labelKey: '@stopEngine', onKey: '@stopEngineOn', offKey: '@stopEngineOff' },
  { key: 'AmberWarningLamp', png: 'mil', labelKey: '@checkEngine', onKey: '@checkEngineOn', offKey: '@checkEngineOff' },
  { key: 'MalfunctionLamp', png: 'awl', labelKey: '@malfunction', onKey: '@malfunctionOn', offKey: '@malfunctionOff' },
  { key: 'ProtectWarningLamp', png: 'protect', labelKey: '@protectEngine', onKey: '@protectEngineOn', offKey: '@protectEngineOff' },
];

export function lampStates(dashboard: { indicators?: { name: string; enabled: boolean }[] } | null | undefined): Lamp[] {
  const indicators = dashboard?.indicators ?? [];
  return LAMPS.map(l => ({ ...l, on: !!indicators.find(i => i.name === l.key)?.enabled }));
}

export function lampSrc(cdnUrl: string, lamp: Lamp): string {
  return `${cdnUrl}/${lamp.png}_${lamp.on ? 'enabled' : 'disabled'}.png`;
}

export function changedLampKeys(atAlert: Lamp[], current: Lamp[] | null): Set<string> {
  if (!current) return new Set();
  return new Set(atAlert.filter(l => current.find(c => c.key === l.key)?.on !== l.on).map(l => l.key));
}
